var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { VNodeFactory } from './VNodeFactory';
let TriggersHost = class TriggersHost extends Vue {
  constructor() {
    super(...arguments);
    this.triggerFactories = [];
  }
  created() {
    this.uc = this.renderer.uc;
    this.ucVNodeFactoryContext = this.renderer.ucVNodeFactoryContext; // new VNodeFactoryContext(this.renderer);
    if (this.uc.isDesignMode) {
      // 设计模式下要考虑变化的问题
      this.$watch(() => this.createTriggerFactories(), () => this.$forceUpdate());
    } else {
      // 非设计模式就运行一次就行
      this.createTriggerFactories();
    }
  }
  /**
   * 根据 renderer.ucPagelet 重建 triggerFactories 这个数组
   *
   * 注意，重建后不会触发当前组件的刷新！！ 如果需要，记得 $forceUpdate 一下
   */
  createTriggerFactories() {
    var _renderer$ucPagelet;
    const {
      uc,
      renderer
    } = this;
    const {
      ucScopedSlotOwner
    } = renderer;
    const triggers = (_renderer$ucPagelet = renderer.ucPagelet) === null || _renderer$ucPagelet === void 0 ? void 0 : _renderer$ucPagelet.triggers;
    const factories = triggers ? triggers.map((layout, index) => new VNodeFactory({
      uc,
      comp: layout,
      isScopeRoot: true,
      parent: ucScopedSlotOwner,
      compPath: `/@triggers/${index}`
    })) : [];
    this.triggerFactories = Object.freeze(factories);
    return factories;
  }
  render() {
    const h = arguments[0];
    const ctx = this.ucVNodeFactoryContext;
    ctx.depend();
    return h("div", [this.triggerFactories.map(factory => factory.toVNode(ctx))]);
  }
};
__decorate([Prop()], TriggersHost.prototype, "renderer", void 0);
TriggersHost = __decorate([Component({
  name: 'UicoreTriggersHost'
})], TriggersHost);
/**
 * 为 CRenderer 创建 TriggersHost，注意，必须在 CRenderer 的 created 阶段调用
 */
export function createTriggersHost(renderer) {
  const host = new TriggersHost({
    parent: renderer,
    propsData: {
      renderer
    }
  });
  renderer.$once('hook:beforeMount', () => {
    host.$mount();
  });
  renderer.$once('hook:beforeDestroy', () => {
    host.$destroy();
  });
  return host;
}
//# sourceMappingURL=TriggersHost.js.map
